import { Position } from 'reactflow';
import { BaseNode } from './baseNode';

export const LLMNode = ({ id }) => {
  const handles = [
    {
      type: 'target',
      position: Position.Left,
      id: `${id}-system`,
      style: { top: '33%' },
    },
    {
      type: 'target',
      position: Position.Left,
      id: `${id}-prompt`,
      style: { top: '67%' },
    },
    {
      type: 'source',
      position: Position.Right,
      id: `${id}-response`,
    },
  ];

  return (
    <BaseNode label="LLM" color="#8b5cf6" handles={handles}>
      <div style={{ fontSize: 11, color: '#64748b', lineHeight: 1.5 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
          <span style={{ color: '#8b5cf6', fontWeight: 600 }}>← system</span>
          <span style={{ color: '#8b5cf6', fontWeight: 600 }}>response →</span>
        </div>
        <div style={{ color: '#8b5cf6', fontWeight: 600 }}>← prompt</div>
        <div style={{
          marginTop: 8,
          padding: '6px 8px',
          background: '#f5f3ff',
          borderRadius: 5,
          fontSize: 10,
          color: '#6d28d9',
        }}>
          Language model inference
        </div>
      </div>
    </BaseNode>
  );
};